import { DtmCustom } from './dtm-custom';
import { DtmProductsInfo } from './dtm-products-info';
import { Dtm, Mapping } from '../shared/enum/dtm';
import { DtmUserInfo } from './dtm-user-info';
import { DtmPageInfo } from './dtm-page-info';

export class DtmDataLayer {
  // Constant Infos
  pageInfo: DtmPageInfo;
  userInfo: DtmUserInfo;

  // Variables Infos
  products: DtmProductsInfo;
  custom: DtmCustom;
  rule: string;

  constructor() { }

  public onCheckoutSuccess(confirmation: any) {
    this.products.confirmacao = confirmation;
  }

  public onCustomLoad(events: Array<any>, checkout?: string, userInfo?: any, custom?: any) {
    this.custom = new DtmCustom();

    if (custom) {
      this.custom = custom;
    }

    if (!this.custom.events) {
      this.custom.events = [];
    }

    events.forEach((event) => {
      this.custom.events.push(event);
    });

    if(checkout) this.custom.checkout = checkout;
    if (userInfo) {
      this.userInfo = new DtmUserInfo(userInfo);
    }
  }

  public onCustomCancellationLoad(events: Array<any>, reason?: string, refund?: boolean) {
    this.custom = new DtmCustom();

    events.forEach((event) => {
      this.custom.events.push(event);
    });

    this.custom.reason = reason;
    this.custom.refund = refund === true;
  }

  public onCustomRetentionLoad(events: Array<any>, reason?: string) {
    this.custom = new DtmCustom();

    events.forEach((event) => {
      this.custom.events.push(event);
    });

    this.custom.reason = reason;
  }

  public onCustomErrorLoad(events: Array<any>, errorData: any) {
    this.custom = new DtmCustom();

    events.forEach((event) => {
      this.custom.events.push(event);
      if(event === 'CreditCardPaymentError') this.custom.triggeredSecondaryCardAutoSelectFeature = errorData.errorTriggeredSecondaryCardAutoSelectFeature;
    });

    this.custom.errorDetail = errorData.errorDetail;
    this.custom.errorMessage = errorData.errorMessage;
    this.custom.customLink = 'customError';
    this.rule = 'customLink';
  }

  public onCustomEventCreditCardPaymentError(events: Array<any>, errorData: any) {
    this.custom = new DtmCustom();

    events.forEach((event) => {
      this.custom.events.push(event);
    });

    this.custom.errorDetail = errorData.errorDetail;
    this.custom.errorMessage = errorData.errorMessage;
    this.custom.customLink = 'customError';
    this.custom.triggeredSecondaryCardAutoSelectFeature = errorData.errorTriggeredSecondaryCardAutoSelectFeature;
    this.rule = 'customLink';
  }

  public onClickLoad(events: Array<any>, clickText: string, clickSection: string) {
    this.custom = new DtmCustom();

    events.forEach((event) => {
      this.custom.events.push(event);
    });

    this.custom.customLink = 'Sydle / CliquesGenericos';
    this.custom.itemClicado = `BTN:MEMEI:Sydle:${clickText}${clickSection ? ':' + clickSection : ''}`;
    this.rule = 'customLink';
  }

  public onLoadSuggestionModal(selectedProduct: string, suggestionProduct: string) {
    this.custom = new DtmCustom();
    this.custom.events.push('SuggestionProductModalImpression');
    this.custom.selectedProduct = selectedProduct;
    this.custom.suggestedProduct = suggestionProduct;

    this.rule = "pageLoad";

  }

  public onClickSuggestionModal(selectedProduct: string, suggestionProduct: string, caseName: string) {
    this.custom = new DtmCustom();
    this.custom.customLink = 'Sydle / CliquesGenericos';

    switch (caseName) {
      case 'ACCEPTED':
        this.custom.itemClicado = `BTN:Sydle:Checkout:CS-RDD: SuggestionProductModal:acceptedSuggestionProductClick:ProductSelected: ${selectedProduct},SuggestionProduct:${suggestionProduct}`;
        break;
      case 'REJECTED':
        this.custom.itemClicado = `BTN:Sydle:Checkout:CS-RDD: SuggestionProductModal:rejectedSuggestionProductClick:ProductSelected: ${selectedProduct},SuggestionProduct:${suggestionProduct}`;
        break;
      case 'CLOSED':
        this.custom.itemClicado = `BTN:Sydle:Checkout:CS-RDD: SuggestionProductModal:closedSuggestionProductClick:ProductSelected: ${selectedProduct},SuggestionProduct:${suggestionProduct}`;
        break;
    }
    this.rule = "customLink";
  }





  public onProductsLoad(products: Array<any>) {
    this.products = new DtmProductsInfo();
    products.forEach((product) => {
      this.products.items.push({
        'category': this.mapProductClassification(product.classificationName),
        'sku': product.identifier ? product.identifier : null,
        'quantity': product.quantity|| 1,
        'price': product.totalValue|| Number(product.value).toFixed(2), 
        'merchandising': product.merchandising
      });
    });
  }

  /** Customizacao das categorias para Adobe Analytics */
  private mapProductClassification(classificationName) {
    const map = {
      "Consulta e Cobrança de Dívidas": "Pacote de Credito MPME",
      "Monitore Clientes": "Monitoramento"
    };
    return map[classificationName] ? map[classificationName] : classificationName;
  }

  public onPageLoad(pageName: string, url: string, logged?: boolean, mappedPageName?: string) {
    switch (pageName) {
      case Dtm.MeuPlano:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'pageLoad';
        break;

      case Dtm.MeuPacote:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url: url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WeB',
        });
        this.rule = 'pageLoad';
        break;

      case Dtm.Identificacao:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'pageLoad';
        break;

      case Dtm.Pagamento:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'pageLoad';
        break;

      case Dtm.PagamentoCompraDeslogada:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'pageLoad';
        break;
      case Dtm.PagamentoReconhecidoDeslogado:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'pageLoad';
        break;
      case Dtm.CadastroDeslogado:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          siteSection: 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.Sucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'customLink';
        break;

      case Dtm.NotFound:
        this.pageInfo = new DtmPageInfo({
          pageName: Dtm.NotFound,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'customLink';
        break;

      case Dtm.AlteracaoDePagamento:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AlteracaoDePagamentoSuccesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.Processando:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url: url,
          siteSection: "LG",
          subSection: "Sydle",
          tipoDeCanal: "WEB",
        });

        this.rule = "pageLoad";
        break;

      case Dtm.RetencaoBoletoVencido:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.RetencaoBoletoVencidoSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AlteracaoDePagamentoRecarga:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AlteracaoDePagamentoRecargaSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.RetencaoCartaoInvalido:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.RetencaoCartaoInvalidoSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.SegundaVia:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.SegundaViaSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;


      case Dtm.AutoAtendimentoSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.RetencaoErroPagamento:
        this.pageInfo = new DtmPageInfo({
          pageName: logged ? mappedPageName : mappedPageName.replace('LG', 'NL'),
          url,
          siteSection: logged ? 'LG' : 'NL',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.Cancelamento:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.CancelamentoSucceso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.RetencaoSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.VitrineUpgrade:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });
        this.rule = 'pageLoad';
        break;
      case Dtm.Upgrade:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.UpgradeSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AtivarRecarga:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AtivarRecargaSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AtivarRecargaPagamento:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AlterarRecarga:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.AlterarRecargaSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.DesativarRecarga:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.DesativarRecargaSucesso:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      case Dtm.DesistirCancelamento:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'CancelarPlanoDesistirCancelamento';
        break;

      case Dtm.DesistirCompra:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'CancelarPlanoDesistirCompra';
        break;

      case Dtm.ProcessamentoTimeout:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;

      default:
        this.pageInfo = new DtmPageInfo({
          pageName: mappedPageName,
          url,
          siteSection: 'LG',
          subSection: 'Sydle',
          tipoDeCanal: 'WEB',
        });

        this.rule = 'pageLoad';
        break;
    }
  }

  public onUserLoad(userData) {
    this.userInfo = new DtmUserInfo(userData);
  }

  public getFormattedDataLayer(event: string) {
    return JSON.stringify(this, null, 4);
  }

  public updateFormattedDataLayer(datalayer: any) { }
}
